import { createI18n } from "vue-i18n";
import zhCN from "./locales/zh-CN";
import enUS from "./locales/en-US";
import thTH from "./locales/th-TH";

export const SUPPORTED_LOCALES = ["zh-CN", "en-US", "th-TH"] as const;

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

const STORAGE_KEY = "public-web-locale";

export function getInitialLocale(): AppLocale {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (SUPPORTED_LOCALES.includes(saved as AppLocale)) return saved as AppLocale;

  const lang = (navigator.language || "").toLowerCase();
  if (lang.startsWith("th")) return "th-TH";
  if (lang.startsWith("en")) return "en-US";
  return "zh-CN";
}

export function setStoredLocale(locale: AppLocale) {
  localStorage.setItem(STORAGE_KEY, locale);
}

export const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: {
    "th-TH": ["en-US", "zh-CN"],
    "en-US": ["zh-CN"],
    default: ["zh-CN"],
  },
  messages: {
    "zh-CN": zhCN,
    "en-US": enUS,
    "th-TH": thTH,
  },
});
